import { LitElement, css, html } from "lit"
import { highlighted } from "../styles/highlighted-style.js"
const { apiFetch } = window.wp
import { nothing } from "lit"
export class Highlighted extends LitElement {
	static get properties() {
		return {
			initialCount: { type: Number },
			postType: { type: String },
			posts: { type: Array, state: true },
      leftAligned: { type: String },
			loading: { type: Boolean, state: true },
			itemColumnCount: { type: Number },
			itemRowCount: { type: Number },
			wp: { type: Object },
			offset: { type: Number },
		}
	}

	static get styles() {
		return highlighted
	}

	constructor() {
		super()
		this.loading = true
		this.posts = []
		this.postType = "posts"
		this.initialCount = 1
		this.offset = 0
		this.wp = window.wp
	}

	getPosts() {
		let url = `/wp/v2/${this.postType}?per_page=${this.initialCount}&offset=${this.offset}`

		apiFetch({
			path: url,
			method: "GET",
		}).then(postList => {
			this.loading = false
			this.loadingMore = false
			if (postList.length === 0) {
				this.showloadmore = false
				return
			}
			this.posts = this.posts.concat(postList)

			this.offset += this.initialCount
		})
	}

	getPostStyle() {
		return css``
	}

	render() {
		if (this.loading) {
			this.getPosts()

			return html` <h1>Loading...</h1> `
		} else {
			console.log(this.leftAligned)
			return html`
					${this.posts.map(
						(post, index) => html`<highlighted-single leftAligned=${this.leftAligned} id=${index} .post=${post}></highlighted-single>`
					)}
			`
		}
	}
}
